import _ from 'lodash';

export default ({ app }, inject) => {
    const objutil = {
        flattenObjectValues (obj) {
            return _.flatMapDeep(obj, (value) =>
                app.$validator.isString(value) ? value : this.flattenObjectValues(Object.values(value))
            ).filter((url) => url.length > 0)
        },
    }
    inject('objutil', objutil);
}